export default {
	title: 'safety',
	icon: 'far fa-shield',
	components: [{ title: 'max_power_protection', component: 'max_power_protection' }],
};
